import React, { FC } from 'react';
import cx from 'classnames';
import useAuth from '../hooks/useAuth';

type LoginLogoutLinkProps = {
  className?: string;
  loginChildren: React.ReactChild;
  logoutChildren: React.ReactChild;
};
/**
 * This will render a login button if sso is enabled and sso cookie exists
 * otherwise it will render a logout button
 */
export const LoginLogoutLink: FC<LoginLogoutLinkProps> = ({
  className,
  loginChildren,
  logoutChildren,
}) => {
  const { handleClick, ssoToken, isSSOEnabled, url } = useAuth();

  return isSSOEnabled ? (
    <a
      className={cx(
        { 'login-link': !ssoToken, 'logout-link': !!ssoToken },
        className
      )}
      onClick={handleClick}
      href={url}
    >
      {ssoToken ? logoutChildren : loginChildren}
    </a>
  ) : null;
};

type LoginLinkProps = {
  className?: string;
};
/**
 * This will render a login button if sso is enabled and sso cookie exists
 * otherwise it will render a logout button
 */
export const LoginLink: FC<LoginLinkProps> = ({ className, children }) => {
  const { handleClick, isSSOEnabled, url } = useAuth({ onlyShowLogin: true });

  return isSSOEnabled ? (
    <a className={cx('login-link', className)} onClick={handleClick} href={url}>
      {children}
    </a>
  ) : null;
};

type AgentLoginLogoutLinkProps = {
  className?: string;
  loginChildren: React.ReactChild;
  logoutChildren: React.ReactChild;
};
/**
 * This will render a login button if sso is enabled and sso cookie exists
 * otherwise it will render a logout button
 */
export const AgentLoginLogout: React.FC<AgentLoginLogoutLinkProps> = ({
  className,
  loginChildren,
  logoutChildren,
}) => {
  const { handleClick, ssoToken, isAgentLoginEnabled, url } = useAuth({
    agentLogin: true,
  });

  return isAgentLoginEnabled ? (
    <a
      className={cx(
        { 'login-link': !ssoToken, 'logout-link': !!ssoToken },
        className
      )}
      onClick={handleClick}
      href={url}
    >
      {ssoToken ? logoutChildren : loginChildren}
    </a>
  ) : null;
};
